// extracted by mini-css-extract-plugin
module.exports = {"boxHeader":"payNextInstallment_boxHeader__2eVa_","removeListIndentation":"payNextInstallment_removeListIndentation__22nUq"};